import { useQuery } from '@apollo/client';
import { FETCH_DASHBOARD_NAME } from '@ovComponents/4-module/dashboard/dashboard.query';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

export const DashboardBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { dashboardId } = useParams();

  const { data } = useQuery(FETCH_DASHBOARD_NAME, {
    variables: { dashboardId: dashboardId ?? '' },
    skip: !dashboardId,
  });

  return data
    ? translateBackendString(
        data.fetchOrganizationDashboard?.dashboard.translatedName,
      )
    : 'Dashboard';
};
